'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.resolveLocalePath = exports.getLocaleFriendlyPathPrefix = exports.getLocaleFriendlyPath = exports.prependPrefix = exports.localeModes = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _regex = require('../regex');

var _patterns = require('../regex/patterns');

var localeModes = exports.localeModes = ['COUNTRY_IN_PATH', 'DOMAIN_ONLY', 'DOMAIN_WITH_LANGUAGE_PATH', 'LANGUAGE_AND_COUNTRY_IN_PATH'];

var prependPrefix = exports.prependPrefix = function prependPrefix(prefix, path) {
	return ('' + prefix + path).toLowerCase();
};

var getLocaleFriendlyPath = exports.getLocaleFriendlyPath = function getLocaleFriendlyPath(path, localeMode, prefix) {
	if (_patterns.externalUrl.test(path)) {
		return path;
	}

	if (path[0] !== '/') {
		console.error('Relative path "' + path + '" cannot be prefixed');
		return;
	}

	switch (localeMode) {
		case 'COUNTRY_IN_PATH':
		case 'LANGUAGE_AND_COUNTRY_IN_PATH':
		case 'DOMAIN_WITH_LANGUAGE_PATH':
			{
				if (!prefix) {
					console.error('Missing prefix for link', path);
					return;
				}

				return '' + prefix + path.replace(/^\//gi, '');
			}
		default:
			return path;
	}
};

var appendSlash = function appendSlash(string) {
	return string ? string.replace(/\/+$/gi, '') + '/' : '/';
};
var prependSlash = function prependSlash(string) {
	return string ? '/' + string.replace(/^\/+/gi, '') : '/';
};

var getLocaleFriendlyPathPrefix = exports.getLocaleFriendlyPathPrefix = function getLocaleFriendlyPathPrefix(languageCode, countryCode, localeMode) {
	if (!localeMode) {
		console.error('Missing parameters. Cannot create prefix with:', { localeMode: localeMode });
		return;
	}

	switch (localeMode) {
		case 'DOMAIN_ONLY':
			{
				return '/';
			}
		case 'COUNTRY_IN_PATH':
			{
				if (!countryCode) {
					console.error('Missing parameters. Cannot create prefix for COUNTRY_IN_PATH with:', { countryCode: countryCode });
					return;
				}

				return ('/' + countryCode + '/').toLowerCase();
			}
		case 'DOMAIN_WITH_LANGUAGE_PATH':
			{
				if (!languageCode) {
					console.error('Missing parameters. Cannot create prefix for DOMAIN_WITH_LANGUAGE_PATH with:', { languageCode: languageCode });
					return;
				}

				return ('/' + languageCode + '/').toLowerCase();
			}
		case 'LANGUAGE_AND_COUNTRY_IN_PATH':
			{
				if (!languageCode || !countryCode) {
					console.error('Missing parameters. Cannot create prefix for DOMAIN_WITH_LANGUAGE_PATH with:', { languageCode: languageCode, countryCode: countryCode });
					return;
				}

				return ('/' + languageCode + '-' + countryCode + '/').toLowerCase();
			}
		default:
			{
				return '/';
			}
	}
};

var resolveLocalePath = exports.resolveLocalePath = function resolveLocalePath(originalPath, localeMode) {
	switch (localeMode) {
		case 'DOMAIN_ONLY':
			{
				return {
					countryCode: false,
					isValid: true,
					languageCode: false,
					path: prependSlash(originalPath),
					prefix: '/'
				};
			}
		case 'COUNTRY_IN_PATH':
			{
				var _getGroupMatches = (0, _regex.getGroupMatches)(_patterns.singleLocalePrefixAndRest, originalPath),
				    _getGroupMatches2 = _slicedToArray(_getGroupMatches, 3),
				    prefix = _getGroupMatches2[0],
				    countryCode = _getGroupMatches2[1],
				    path = _getGroupMatches2[2];

				var isValid = Boolean(prefix);

				return {
					countryCode: countryCode,
					isValid: Boolean(prefix),
					languageCode: false,
					path: isValid && prependSlash(path),
					prefix: prefix && appendSlash(prefix).toLowerCase()
				};
			}
		case 'DOMAIN_WITH_LANGUAGE_PATH':
			{
				var _getGroupMatches3 = (0, _regex.getGroupMatches)(_patterns.singleLocalePrefixAndRest, originalPath),
				    _getGroupMatches4 = _slicedToArray(_getGroupMatches3, 3),
				    _prefix = _getGroupMatches4[0],
				    languageCode = _getGroupMatches4[1],
				    _path = _getGroupMatches4[2];

				var _isValid = Boolean(_prefix);

				return {
					countryCode: false,
					isValid: Boolean(_prefix),
					languageCode: languageCode,
					path: _isValid && prependSlash(_path),
					prefix: _prefix && appendSlash(_prefix).toLowerCase()
				};
			}
		case 'LANGUAGE_AND_COUNTRY_IN_PATH':
			{
				var _getGroupMatches5 = (0, _regex.getGroupMatches)(_patterns.doubleLocalePrefixAndRest, originalPath),
				    _getGroupMatches6 = _slicedToArray(_getGroupMatches5, 4),
				    _prefix2 = _getGroupMatches6[0],
				    _languageCode = _getGroupMatches6[1],
				    _countryCode = _getGroupMatches6[2],
				    _path2 = _getGroupMatches6[3];

				var _isValid2 = Boolean(_prefix2);

				return {
					countryCode: _countryCode,
					isValid: _isValid2,
					languageCode: _languageCode,
					path: _isValid2 && prependSlash(_path2),
					prefix: _prefix2 && appendSlash(_prefix2).toLowerCase()
				};
			}
		default:
			{
				return false;
			}
	}
};